import { render, staticRenderFns } from "./CampaignSchoolResult.vue?vue&type=template&id=a8c2d240&"
import script from "./CampaignSchoolResult.vue?vue&type=script&lang=js&"
export * from "./CampaignSchoolResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports